import { render, staticRenderFns } from "./PreviewNews.vue?vue&type=template&id=49863e02&scoped=true&"
import script from "./PreviewNews.vue?vue&type=script&lang=js&"
export * from "./PreviewNews.vue?vue&type=script&lang=js&"
import style0 from "./PreviewNews.vue?vue&type=style&index=0&id=49863e02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49863e02",
  null
  
)

export default component.exports